import { Validator } from '@vista-digital/validator';
/**
 * Default config specific to normal item modifiers.
 */
export const defaultItemPickerNormalItemModifiersConfig = {
    showExpandedByDefault: true,
    showImages: true
};
export const itemPickerNormalItemModifiersConfigValidator = Validator.object({
    showExpandedByDefault: Validator.boolean(),
    showImages: Validator.boolean()
});
